import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    "@keyframes qualityFlashPulse": {
        "0%, 100%": {
            backgroundColor: theme.palette.secondary.main,
            boxShadow: "0px 2px 0px rgba(62, 93, 138, 0.2)",
        },
        "50%": {
            backgroundColor: theme.palette.warning.main,
            boxShadow: "0px 0px 12px rgba(239, 128, 39, 0.6)",
        },
    },
    qualityButton: {
        "&.MuiButton-root": {
            height: "45px",
            minWidth: "140px",
            padding: "0 24px",
            borderRadius: "4px",
            boxShadow: "0px 2px 0px rgba(62, 93, 138, 0.2)",
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.text.primary,
            fontFamily: "Source Sans 3",
            fontSize: "22px",
            fontWeight: 400,
            textTransform: "none",
            lineHeight: 1,
            "&:hover": {
                backgroundColor: theme.palette.primary.main,
                boxShadow: "0px 2px 0px rgba(62, 93, 138, 0.2)",
            },
            "&:focus-visible": {
                outline: `2px solid ${theme.palette.secondary.main}`,
                outlineOffset: "2px",
            },
            marginBottom: "5px",
        },
    },
    qualityButtonFlashing: {
        "&.MuiButton-root": {
            animation: "$qualityFlashPulse 1.2s ease-in-out infinite",
        },
        "@media (prefers-reduced-motion: reduce)": {
            "&.MuiButton-root": {
                animation: "none",
                backgroundColor: theme.palette.warning.main,
                color: "#FFFFFF",
            },
        },
    },
}));
